import React, { useState } from 'react';
import { TableBody, TableCell, TableHead, TableRow, IconButton, Typography, Button, Stack, Box, useTheme, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate } from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useEffect } from 'react';
import { customAlert, notify } from '../../../components/notify';
import { useAuthContext } from '../../../context/AuthContext';
import route from '../../../utils/Routes';
import { createDeptServ } from '../../../services/dept-service';
import BgBoxOld from '../../../components/BgBoxOld';
import { Add } from '@mui/icons-material';
import { isNotEmpty } from '../../../utils/format';

function CreateDeptPage() {
    const theme = useTheme()
    const navigate = useNavigate();
    const { setLoadingScreen } = useAuthContext();
    const location = useLocation();
    const { comId, projId, actProjIdStrg } = location.state || {};
    const [depts, setDepts] = useState([]);
    const [deptName, setDeptName] = useState("")
    const columns = [
        {
            id: 'id',
            label: "S .No",
            align: 'left',
            minWidth: 150,
        },
        {
            id: 'name',
            label: "Department",
            align: 'left',
            minWidth: 150,
        },
        {
            id: '',
            label: "",
            align: 'right',
            minWidth: 150,
        },
    ];

    useEffect(() => {
        if (!comId)
            navigate("/", { replace: true })
        else if (!projId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comId, projId])

    const handleDelete = (index) => {
        const updatedDepts = [...depts];
        updatedDepts.splice(index, 1);
        setDepts(updatedDepts);
    };

    function handleAddDept() {
        if (isNotEmpty(deptName)) {
            setDepts((prev) => [...prev, { name: deptName }]);
            setDeptName("")
        }
    };


    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        if (depts.length === 0) {
            notify("error", "At least one department should be added!")
            return;
        }
        setLoadingScreen(true);
        try {
            const payload = {
                projIdStrg: projId,
                deptNameArr: depts.map((i) => i.name)

            }
            const { message } = await createDeptServ(payload);
            notify("success", message);
            navigate(`${route.cProjInfo}/?projId=${projId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    async function handleCancel() {
        navigate(`${route.cProjInfo}/?projId=${projId}`, { replace: true });
    }


    return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
        <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
            <BackButton width={"20%"} />
            <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"60%"}>
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create Department (Project Id : {actProjIdStrg})</Typography>
            </Stack>
            <Box width={"20%"} />
        </Stack>
        <BgBoxOld height={"93%"} py={1}>
            <Stack width={"100%"} height={"100%"}>
                <Stack direction={"row"} justifyContent={"center"} width={"100%"} mt={2} mb={2}>

                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                        <Typography sx={{ fontSize: 14, fontWeight: 500, color: "rgb(0,0,0,0.8)" }}> Department: </Typography>
                        <TextField placeholder="Enter Department Name..." value={deptName}
                            onChange={(e) => setDeptName(e.target.value)}
                            variant="outlined" sx={{ '& .MuiOutlinedInput-root': { width: 300, height: 35, fontSize: 13, ml: 1 } }} />
                        <Button onClick={handleAddDept} variant="contained" startIcon={<Add />}
                            sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 35 }}>
                            ADD
                        </Button>
                    </Stack>

                </Stack>
                <StyledTableContainer height={"75%"} isStickyHeader={true}>
                    <TableHead sx={{ backgroundColor: "rgba(253, 240, 213, 0.4)" }}>
                        <TableRow>
                            {columns.map((column, index) => (
                                <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={index} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {depts.map((i, index) => (
                            <TableRow key={index}  >
                                <TableCell sx={{ fontWeight: 500, fontSize: 13 }}>{index + 1}.</TableCell>
                                <TableCell sx={{ fontWeight: 500, fontSize: 13 }}>{i.name}</TableCell>
                                <TableCell sx={{ fontWeight: 500, fontSize: 13 }} align="right">
                                    <IconButton
                                        aria-label="delete" color='error'
                                        onClick={() => handleDelete(index)}>
                                        <CloseIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </StyledTableContainer>
                <Stack direction={"row"} alignItems={"center"} sx={{ width: "100%", justifyContent: "end", mt: 2 }} >
                    <Button variant="outlined" onClick={handleCancel} sx={{
                        fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                        color: theme.palette.custom.btn, mr: 2,
                    }}>CANCEL</Button>
                    <Button variant="contained" type="submit"
                        sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", mr: 10 }}>
                        CREATE</Button>
                </Stack>
            </Stack>
        </BgBoxOld>
    </form>
    );
}
export default CreateDeptPage;